import { createSelector } from '@ngrx/store';
import { State as AppState } from '@app/core/store/reducers';
import { LegalDocumentsState } from '@app/core/store/legal-documents/reducers';

export const featureSelector = (state: AppState): LegalDocumentsState => state.legalDocuments;

export const selectCookiePolicy = createSelector(
  featureSelector,
  (state: LegalDocumentsState) => state.cookiePolicy,
);

export const selectPrivacyPolicy = createSelector(
  featureSelector,
  (state: LegalDocumentsState) => state.privacyPolicy,
);

export const selectTerms = createSelector(
  featureSelector,
  (state: LegalDocumentsState) => state.terms,
);

export const selectAllLegalDocuments = createSelector(
  featureSelector,
  ({ terms, privacyPolicy, cookiePolicy }: LegalDocumentsState) => ({ terms, privacyPolicy, cookiePolicy }),
);
